import { Link } from 'react-router-dom';

export default function RelatedArticles() {
  const articles = [
    {
      title: 'PDF性能优化最佳实践',
      excerpt: '了解如何优化PDF处理性能，提升应用程序响应速度',
      date: '2024-01-15',
      category: '技术博客',
      link: '/blog-pdf-performance',
      image: 'https://public.readdy.ai/ai/img_res/5a60f0c2d875c2d48f6a67b4422ff0a2.jpg',
    },
    {
      title: 'PDF表单数据提取技术',
      excerpt: '深入探讨PDF表单数据提取的各种方法和技术实现',
      date: '2024-01-10',
      category: '技术博客',
      link: '/blog-form-extraction',
      image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20illustration%20of%20PDF%20form%20data%20extraction%20process%2C%20abstract%20representation%20of%20digital%20forms%20and%20data%20fields%20being%20analyzed%2C%20minimalist%20design%20with%20teal%20and%20cyan%20accent%20colors%20on%20white%20background%2C%20geometric%20shapes%20showing%20data%20flow%20from%20forms%20to%20structured%20information%2C%20professional%20technical%20visualization%20with%20simple%20lines%20and%20contemporary%20style&width=800&height=600&seq=form-extraction-article-v1&orientation=landscape',
    },
    {
      title: '云架构中的PDF处理',
      excerpt: '探索在云环境中部署和扩展PDF处理服务的最佳实践',
      date: '2024-01-05',
      category: '技术博客',
      link: '/blog-cloud-architecture',
      image: 'https://readdy.ai/api/search-image?query=Modern%20abstract%20illustration%20of%20cloud%20computing%20architecture%20for%20PDF%20processing%2C%20minimalist%20design%20showing%20cloud%20infrastructure%20with%20document%20workflow%2C%20clean%20teal%20and%20cyan%20color%20palette%20with%20white%20background%2C%20geometric%20shapes%20representing%20servers%20and%20data%20flow%2C%20contemporary%20technical%20diagram%20with%20simple%20elegant%20style%20showing%20scalable%20cloud%20services&width=800&height=600&seq=cloud-architecture-article-v1&orientation=landscape',
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            相关文章
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            深入了解PDF技术和最佳实践
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((article) => (
            <Link
              key={article.title}
              to={article.link}
              className="bg-white rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300 hover:scale-105 cursor-pointer group"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-4 mb-4 text-sm text-gray-500">
                  <span className="bg-teal-100 text-teal-700 px-3 py-1 rounded-full font-medium">
                    {article.category}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center text-teal-600 font-semibold group-hover:gap-2 transition-all">
                  阅读更多
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
